import React from "react";

import styled from "@emotion/styled";

import Clickable from "../../../../Clickable";
import { Link } from "../../../../LinkComponent";
import ShoppingCart from "../../../ShoppingCart";
import TechnicList from "../../../TechnicList";
import Phone from "../../../Phone";
import Contact from "../../../Contact";
import Language from "../../../Language";
import HoyerCard from "../../../HoyerCard";
import IconContainer from "../../../../icons/Icon/IconContainer";
import { css } from "@emotion/react";
import { useLocation } from "@gatsbyjs/reach-router";

interface iProps {
    active?: boolean;
}

export const LinkItem = styled(Link)<iProps>`
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        flex-direction: row;
    `}
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.blue.toString()};
    font-weight: 500;
    font-size: 12px;

    &:hover,
    &:focus,
    &:active {
        color: ${({ theme }) => theme.colors.blue.toString()};
        text-decoration: underline;
        text-decoration-thickness: 2px;
    }
    ${({ active }) =>
        active &&
        css`
            text-decoration: underline;
            text-decoration-thickness: 2px;
        `};
`;

export const LinkItemClickable = LinkItem.withComponent(Clickable);

export const StyledIconContainer = styled(IconContainer)`
    position: relative;
    display: flex;
    align-items: center;
    width: 18px !important;
    height: 18px !important;
    svg {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px !important;
        height: 18px !important;
    }
    ${({ theme }) => theme.breakpoints.from.medium.css`
        margin-right: 10px;
    `};
`;

export const SubNavContainer = styled.div`
    flex-grow: 1;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.from.medium.css`
        position: relative;
    `}

    ${({ theme }) => theme.breakpoints.from.normal.css`
        flex-grow: 0;
    `}

    > div {
        visibility: hidden;
    }

    &.active > div {
        visibility: visible;
    }
`;

const UtilityNav = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    font-size: 0.9rem;
`;

const LinkItems = ({
    sections,
    organization,
}: {
    sections: any;
    organization: any;
}) => {
    const location = useLocation();

    const hideElement =
        location.pathname === "/unternehmen/grundsaetze/integritaetskanal/";

    const telName = "Telefon";

    const PhoneItem = organization?.telephone && (
        <Phone defaultPhoneNumber={organization.telephone} telName={telName} />
    );

    return (
        <UtilityNav>
            <HoyerCard />
            <TechnicList />
            <ShoppingCart />
            <Language section={sections[5]} />
            {!hideElement && (
                <>
                    <Contact />
                    {PhoneItem}
                </>
            )}
        </UtilityNav>
    );
};

export default LinkItems;
